import { MantineTheme, Sx } from '@mantine/core';

export const webhooksStyles = (theme: MantineTheme): Sx => {
  return {};
};
